import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitBtn", "inputHidden", "planText"];

  connect() {
    try {
      // Attach an event listener to the radio buttons
      this.element.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener("change", () => this.handlePlanChange());
      });

      // Initially set the class based on the checked radio button
      this.handlePlanChange();
    } catch (error) {
      console.error("Error in connect:", error);
    }
  }

  handlePlanChange() {
    const checkedRadio = this.element.querySelector(
      'input[type="radio"]:checked'
    );
    const priceYearId = this.submitBtnTarget.getAttribute(
      "data-price-year-value"
    );
    const priceMonthId = this.submitBtnTarget.getAttribute(
      "data-price-month-value"
    );

    if (checkedRadio && checkedRadio.checked) {
      // Update button state
      this.submitBtnTargets.forEach((button) => {
        button.classList.remove("disabledBtn");
      });

      // Update hidden input value
      if (checkedRadio.id === "plan-annual") {
        this.inputHiddenTarget.value = priceYearId;
      } else {
        this.inputHiddenTarget.value = priceMonthId;
      }

      // Show/hide appropriate days text
      const selectedPlan = checkedRadio.getAttribute("data-plan");
      this.planTextTargets.forEach((span) => {
        span.classList.toggle(
          "hidden",
          span.getAttribute("data-plan") !== selectedPlan
        );
      });
    } else {
      this.submitBtnTargets.forEach((button) => {
        button.classList.add("disabledBtn");
      });
    }
  }
}
